import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugBrexipiprazole} from "./TextDrugBrexipiprazole"


export default function Brexipiprazole() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      

    <ButtonsText onClick={handleOpen} name='Brexipiprazole' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Brexipiprazole - PGx Recommendation"
        content={ <TextDrugBrexipiprazole />}

        />

</>
)}